import type { MeasurementDimensionSpec } from './measurement-dimension.js';

/**
 * ISO 216 A4, 210 × 297 mm, with A5 (148 × 210 mm) nested against the same
 * corner. The ratio 297 / 210 = 1.414 is √2 to three decimals, which is why
 * halving an A4 gives an A5 of the same shape; ISO rounds 210 / √2 = 148.49 down
 * to 148 mm, and the figure says so rather than pretending the fold is exact.
 */
export function measurementDimensionFixture(width = 640): MeasurementDimensionSpec {
  return {
    id: 'a4-sheet',
    family: 'measurement-dimension',
    view: 'orthographic',
    viewport: { width, height: 470 },
    subject: 'ISO 216 paper',
    unit: 'mm',
    object: { id: 'a4', label: 'A4', measuredWidth: 210, measuredHeight: 297 },
    inset: { id: 'a5', label: 'A5', measuredWidth: 148, measuredHeight: 210 },
    derived: [
      { id: 'ratio', label: 'Aspect ratio', expression: '297 / 210 = 1.414', compare: '√2 = 1.41421' },
      { id: 'fold', label: 'Half of A4', expression: '210 / √2 = 148.49', compare: 'ISO rounds down to 148 mm' },
    ],
    scaleBar: 50,
    title: 'The number and the drawn length have to agree',
    subtitle: 'A4 halves into A5 with the same proportions because the ratio is √2 — and the standard rounds the fold down to a whole millimetre.',
    provenance: 'ISO 216 trimmed sizes: A4 210 × 297 mm, A5 148 × 210 mm',
  };
}
